// extracted by mini-css-extract-plugin
export var button = "_bq-7";
export var buttonRow = "_bq-6";
export var fadeIn = "_bq-1";
export var gradient = "_bq-0";
export var panel = "_bq-2";
export var panelIn = "_bq-3";
export var subtitle = "_bq-5";
export var title = "_bq-4";